export default "__VITE_ASSET__a834190e__"